import { useState, useEffect, useRef,  } from 'react'
import loadable from '@loadable/component'
import { Helmet } from "react-helmet-async"
import { arrayMoveImmutable } from 'array-move'

import type {
    TPossibleScreens,
    TUpload,
    TUploadedFile,
    TUploadingError,
    TErrorText,
    TPage,
    TSignType,
    TSign,
} from "../types"

import {
    saveThumb,
    loadThumb,
    textSign,
} from '../helpers'

import { baseURL, development, isSnap } from '../constants'

import { statOnLoad } from '../Stat'

import Wrapper from "../elements/Wrapper"
import DefaultContent, { Content, SignContent } from "../elements/Content"

import {
    Buttons,
    UploadButtons,
    CloudButtons,
    ButtonOneDrive,
    ButtonDropBox,
    ButtonGoogleDrive,

    PagePreviwButtons,
    PagePreviwButton,
} from "../elements/Buttons"

import { convert, localUpload } from "../Services"

import DropZone from "../screens/DropZone"
import { SignH1 } from "../screens/Sign"

const ErrorBlock = loadable(() => import('../elements/Errors'))
const PagesPreview = loadable(() => import('../screens/PagesPreview'))
const Preloader = loadable(() => import("../screens/Preloader"))
const Download = loadable(() => import("../screens/Download"))
const Error = loadable(() => import("../screens/Error"))
const Sign = loadable(() => import("../screens/Sign"))
const Edit = loadable(() => import("../elements/Edit"))

const uploadedFilesT: TUploadedFile[] = []
const uploadingErrors: TUploadingError[] = []
let downloadLink: string
let defaultPagesLength: number

const SignPDF = () => {
    const [currentScreen, switchScreen] = useState<TPossibleScreens>('filespreview')//('filespreview')
    const [progress, setProgress] = useState(0)
    const [uploadedFiles, setUploadedFiles] = useState<TUploadedFile[]>(uploadedFilesT)
    const [countUploadingErrors, setCountUploadingErrors] = useState(uploadingErrors.length)
    const [errorText, setErrorText] = useState<TErrorText>({})
    const [showErrorBlock, setShowErrorBlock] = useState(true)
    const [pages, setPages] = useState<TPage[]>([])
    const [disableButton, setDisableButton] = useState(true)


    const [signType, setSignType] = useState<TSignType>('draw')
    const [colorIndex, setColorIndex] = useState(0)
    const [fontIndex, setFontIndex] = useState(0)
    const [userName, setUserName] = useState('')
    const [signImg, setSignImg] = useState<string | undefined>(undefined)
    const [signs, setSigns] = useState<TSign[]>([])
    const [signed, setSigned] = useState(false)

    const [prep, setPrep] = useState('Uploading File')

    const [editPage, setEditPage] = useState<number | null>(null)

    const upload: TUpload = {

        action: "sign_pdf",
        allowExtantions: ['pdf'],
        convertTo: "pdf",
        maxSize: 25, // MB
        multiselect: false,


        setDownloadLink: (link: string) => downloadLink = link,
        getDownloadLink: () => downloadLink,
        setProgress: (progress) => setProgress(progress),
        getProgress: () => progress,
        setScreen: (screen) => {
            if (window.scrollY > 220) window.scrollTo({ top: 0, behavior: "smooth" })
            if (screen === 'uploading' || screen === 'converting' || screen === 'preparing') setProgress(0)
            return switchScreen(screen)
        },
        getScreen: () => currentScreen,
        addFiles: (uploadedFile) => {
            return setUploadedFiles([...uploadedFile])
        },
        delFile: (uploadedFile) => {
            return setUploadedFiles(uploadedFiles.filter((element) => element !== uploadedFile))
        },
        clearFiles: () => setUploadedFiles([]),
        getFiles: () => uploadedFiles,
        moveFiles: (oldIndex, newIndex) => {
            return setUploadedFiles(arrayMoveImmutable(uploadedFiles, oldIndex, newIndex))
        },
        addError: (uploadingError) => {
            uploadingErrors.push(uploadingError)
            setShowErrorBlock(true)
            return setCountUploadingErrors(countUploadingErrors + 1)
        },
        delError: (uploadingError) => {
            const idx = uploadingErrors.indexOf(uploadingError)
            if (idx !== -1) {
                uploadingErrors.splice(idx, 1)
                return setCountUploadingErrors(countUploadingErrors - 1)
            }
        },
        clearErrors: () => {
            uploadingErrors.splice(0, uploadingErrors.length)
            return setCountUploadingErrors(0)
        },
        hideErrors: () => setShowErrorBlock(false),
        getErrors: () => uploadingErrors,
        setErrorText: setErrorText,

        getPages: () => pages,
        setPages: (newPages) => {
            if (newPages.length != defaultPagesLength ||
                newPages.some((e, i) => {
                    return e.page_num != i || e.rotate % 360 != 0
            })) setDisableButton(false)
            else setDisableButton(true)

            return setPages(newPages)
        },
        setDefaultPages: (pages) => {
            defaultPagesLength = pages.length
            return saveThumb(pages)
        },
    }

    // Рабочий код для uuid
    // useEffect(() => {
        
    //     const token = location.hash.replace('#', '')
    //     if (token.length === 36) {
    //         location.hash = ''
    //         localUpload(upload, token)
    //     }
    //     else statOnLoad(upload)
    // }, [])
   
    // useEffect(() => {
    //     // 
    //     const token = location.hash
        
    //     // 
    //     if (token.includes("#")) {
    //         location.hash.replace('#', '')
    //         localUpload(upload, token)
    //     }
    //     else statOnLoad(upload)

    //     // 
    //     if (token.includes("#id=")) {
    //         location.hash.slice(0,3)
    //         localUpload(upload, token)
    //     }
    //     else statOnLoad(upload)

    //     if(token) {
    //         Number.isInteger((location.hash)) && String(Number(location.hash)) == location.hash
    //         localUpload(upload, token)
    //     }
    //     else statOnLoad(upload)

    //     if (token.length === 36) {
    //         location.hash.slice(0,3).toLocaleLowerCase().toString() === '#id='
    //         localUpload(upload, token)
    //     }
    //     else statOnLoad(upload)
    // }, [])


    useEffect(() => {
        
        const token = location.hash.replace('#', '')

        if (token.includes("id=")) {
            const docid = token.slice(3);
            if (Number.isInteger(Number(docid)) && String(Number(docid)) == docid) {
                localUpload(upload, docid, true)
                setPrep('Prepairing File')
            }
        }
        else if (token.length === 36) {
            localUpload(upload, token)
            setPrep('Prepairing File')
        }
        else statOnLoad(upload)
    },[])
   

    const isSignScreen = () => (
        (currentScreen === 'uploading' || currentScreen === 'preparing') &&
        !signed
    ) || (
        currentScreen === 'filespreview' &&
        uploadedFiles.length > 0 &&
        pages.length > 0 &&
        !signed
    )

    return (
        <Wrapper>
            <Helmet>
                <title>Sign PDF | Templateroller</title>
                <meta name="keywords" content="how to sign a pdf, sign pdf, how to sign a pdf document, how to digitally sign a pdf, how to electronically sign a pdf, sign pdf online, sign pdf online free, sign a pdf, how to sign pdf, digitally sign pdf, sign a pdf document" />
                <meta name="description" content="Need to sign PDF documents? Electronically sign a PDF with TemplateRoller's free easy to use tool." />
                <meta property='og:title' content="Sign PDF" />
                <meta property='og:description' content="Need to sign PDF files? Use our service to digitally sign PDF documents easily and for free." />
                <meta property='og:url' content={`${baseURL}/tools/sign-pdf.html`} />
                <meta property="og:image" content={`${baseURL}/tools/assets/og-sign-pdf.png`} />
                <meta property='og:locale' content="en_US" />
                <meta property='twitter:title' content="Sign PDF" />
                <meta property='twitter:description' content="Need to sign PDF files? Use our service to digitally sign PDF documents easily and for free." />
                <meta property="twitter:image:src" content={`${baseURL}/tools/assets/og-sign-pdf.png`} />
                <link rel='canonical' href={`${baseURL}/tools/sign-pdf.html`} />
            </Helmet>

            {   // Начальный экран
                currentScreen === 'filespreview' &&
                (uploadedFiles.length === 0 || pages.length === 0) &&
                <h1>Sign PDF</h1>
            }

            {   // Рисовалка подписи
                isSignScreen() &&
                signType === 'draw' &&
                <SignH1>Create your signature</SignH1>
            }

            {   // Загрузка подписи
                isSignScreen() &&
                signType === 'upload' &&
                <SignH1>Upload image with a signature</SignH1>
            }

            {   // Ввод подписи
                isSignScreen() &&
                signType === 'text' &&
                <SignH1>Type your name and initials</SignH1>
            }

            {   // Экран превью страниц
                currentScreen === 'filespreview' &&
                uploadedFiles.length > 0 &&
                pages.length > 0 &&
                signed &&
                <SignH1>Choose page to be signed</SignH1>
            }

            {
                currentScreen === 'filespreview' &&
                (uploadedFiles.length === 0 || pages.length === 0) &&
                <DefaultContent>
                    {
                        countUploadingErrors > 0 &&
                        showErrorBlock &&
                        <ErrorBlock upload={upload} />
                    }

                    <DropZone
                        title="Sign PDF online: drag and drop PDF file to sign document"
                        description="Need to sign PDF documents? Electronically sign a PDF with TemplateRoller’s free easy to use tool."
                        buttonText="Browse file"
                        warning={`Upload document of up to ${upload.maxSize} MB in ${(upload.allowExtantions.length > 2 ? upload.allowExtantions.map((e, i) => i == upload.allowExtantions.length - 1 ? `and .${e}` : `.${e}`) : upload.allowExtantions.map(e => `.${e}`)).join(', ')} format${upload.allowExtantions.length > 1 ? 's' : ''}`}

                        upload={upload}
                    />
                    <Buttons>
                        <UploadButtons>
                            <CloudButtons>
                                <ButtonDropBox upload={upload} />
                                <ButtonOneDrive upload={upload} />
                                <ButtonGoogleDrive upload={upload} />
                            </CloudButtons>
                        </UploadButtons>
                    </Buttons>

                </DefaultContent>

            }

            {
                isSignScreen() &&
                <SignContent>
                    <Sign
                        type={signType}
                        setType={setSignType}
                        colorIndex={colorIndex}
                        setColorIndex={setColorIndex}
                        userName={userName}
                        setUserName={setUserName}
                        fontIndex={fontIndex}
                        setFontIndex={setFontIndex}
                        signImg={signImg}
                        setSignImg={setSignImg}
                    />
                    <Buttons>
                        <PagePreviwButtons>
                            <PagePreviwButton
                                primary={true}
                                disabled={
                                    signType === 'text'
                                        ? !userName.trim().length
                                        : !signImg
                                }
                                onClick={() => {
                                    if (signType === 'text') {
                                        const png = textSign(userName, fontIndex, colorIndex)
                                        if (png) setSignImg(png)
                                    }
                                    setSigned(true)
                                }}
                            >Сontinue</PagePreviwButton>
                        </PagePreviwButtons>
                    </Buttons>
                </SignContent>
            }
                
            {
                currentScreen === 'filespreview' &&
                uploadedFiles.length > 0 &&
                pages.length > 0 &&
                signed &&
                <Content>
                    {
                        countUploadingErrors > 0 &&
                        showErrorBlock &&
                        <ErrorBlock upload={upload} />
                    }

                    <PagesPreview
                        upload={upload}
                        sortable={false}
                        setEditPage={setEditPage}
                        signs={signs}
                    />

                    <Edit 
                        signs={signs}
                        setSigns={setSigns}
                        editPage={editPage}
                        setEditPage={setEditPage}
                        pages={pages}
                        signImg={signImg}

                        signType={signType}
                        colorIndex={colorIndex}
                        fontIndex={fontIndex}
                        userName={userName}
                    />

                    <Buttons>
                        <PagePreviwButtons>
                            <PagePreviwButton
                                primary={false}
                                onClick={() => {
                                    if (signs.length === 0) {
                                        if (confirm('Do you want to upload again?')) {
                                            setSignImg(undefined)
                                            setUserName('')
                                            setSigned(false)
                                            setUploadedFiles([])
                                            return setPages([])
                                        }
                                    }
                                    else {
                                        if (confirm('Do you want to clear all signatures?')) {
                                            return setSigns([])
                                        }
                                    }
                                }}
                            >{`${signs.length === 0 ? 'Reset' : 'Undo'}`}</PagePreviwButton>
                            <PagePreviwButton
                                primary={true}
                                disabled={signs.length === 0}
                                onClick={() => {
                                    return convert({
                                        upload: upload,
                                        signs,
                                        signImg,
                                    })
                                }}
                            >Apply</PagePreviwButton>
                        </PagePreviwButtons>
                    </Buttons>
                </Content>
            }

            {
                currentScreen === 'uploading' &&
                signed &&
                <DefaultContent>
                    <Preloader
                        type="progress"
                        title="Uploading File"
                        description="Don’t close this tab, your files are being uploaded. This shouldn’t take long."
                        progress={progress}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'preparing' &&
                signed &&
                <DefaultContent>
                    <Preloader
                        type="progress"
                        title="Preparing Pages"
                        description="Don’t close this tab, your files are being prepared. This won't take long."
                        progress={progress}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'converting' &&
                <DefaultContent>
                    <Preloader
                        type="progress"
                        title="Processing Document"
                        description="Don’t close this tab, your files are being processed. This won't take long."
                        progress={progress}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'link' &&
                <DefaultContent>
                    <Download
                        title="Download Signed PDF"
                        description="Your file has been signed. Click on “Download” to save the file to your device."
                        buttonText="Download"

                        upload={upload}
                        onClick={() => {
                            // @ts-ignore
                            window.stat?.(`tools_result_${upload.action}`)
                        }}
                    />
                </DefaultContent>
            }

            {
                currentScreen === 'error' &&
                <DefaultContent>
                    <Error text={errorText} />
                </DefaultContent>
            }

        </Wrapper>
    )
}

export default SignPDF